import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeIsLoggedUserPowerUser } from "~/store/selectors/selector.users";

export const RequirePowerUser = ({ children, redirectTo }) => {
  const getIsPowerUser = useMemo(makeIsLoggedUserPowerUser, []);
  const isPowerUser = useSelector((state) => getIsPowerUser(state));

  return isPowerUser ? children : <Navigate to={redirectTo} />;
};

RequirePowerUser.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequirePowerUser.defaultProps = {
  redirectTo: "/not-found",
};
